import { FC, memo } from 'react';
import { Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { WbTruncatedTypographyWrapper } from '@agilelab/plugin-wb-platform';
import { SeverityTooltip, Severity } from '@agilelab/plugin-wb-platform';

interface EntityCardTitleProps {
  name: string;
  loading: boolean;
  route: string;
  error?: string;
}

export const EntityCardTitle: FC<EntityCardTitleProps> = memo(
  ({ name, loading, route, error }) => {
    return loading ? (
      <WbTruncatedTypographyWrapper
        value={name}
        maxLines={1}
        style={{ fontWeight: 700 }}
        enableTooltip
        placement="top-start"
      />
    ) : (
      <Box style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <Link to={route}>
          <WbTruncatedTypographyWrapper
            value={name}
            maxLines={1}
            style={{ fontWeight: 700 }}
            enableTooltip
            placement="top-start"
          />
        </Link>
        {error && (
          <SeverityTooltip
            severity={Severity.Error}
            label={error}
            iconSize="inherit"
          />
        )}
      </Box>
    );
  },
);

EntityCardTitle.displayName = 'EntityCardTitle';
